define('file', function () {
    return {
        load: function (name, require, onload, config) {
            onload(require.toUrl(name));
        }
    };
});
